import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Feedback.css";

function Feedback() {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_FLASK_API_URL}/feedback`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setQuestions(data);
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to load questions.");
        setLoading(false);
      });
  }, []);

  const handleChange = (id, category, text, value) => {
    setAnswers((prevAnswers) => ({
      ...prevAnswers,
      [id]: { value, text, category }, // Save both value, text, and category of each question
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Ensure answers object is populated correctly
    const allAnswers = { ...answers };

    // Log the answers to verify structure before sending
    console.log("Answers being submitted:", allAnswers);

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/submit-feedback`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            answers: allAnswers, // Send answers as an object in the request body
          }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log(result.message); // Success message from backend
        navigate(`/results`);
      } else {
        const result = await response.json();
        console.error("Failed to submit feedback:", result.error);
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
    }
  };

  if (loading) return <p>Loading questions...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="feedback-container">
      <h1>Feedback Form</h1>
      <form onSubmit={handleSubmit} className="p-4">
        {/* Separate Application and Tool feedback */}
        <h2>Application Feedback</h2>
        {questions
          .filter((q) => q.category === "ApplicationFeedback")
          .map((question) => (
            <div key={question.id} className="feedback-question">
              <label className="feedback-label">{question.text}</label>

              {question.type === "text" ? (
                <textarea
                  type="text"
                  name={question.id}
                  className="feedback-input"
                  onChange={(e) =>
                    handleChange(
                      question.id,
                      question.category,
                      question.text,
                      e.target.value
                    )
                  }
                />
              ) : question.type === "select" ? (
                <select
                  name={question.id}
                  className="feedback-input"
                  onChange={(e) =>
                    handleChange(
                      question.id,
                      question.category,
                      question.text,
                      e.target.value
                    )
                  }
                >
                  <option value="">Select an option</option>
                  {question.options.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              ) : question.type === "radio" ? (
                <div className="radio-options">
                  {question.options.map((option, index) => (
                    <label key={index} className="radio-label">
                      <input
                        type="radio"
                        name={question.id}
                        value={option}
                        onChange={(e) =>
                          handleChange(
                            question.id,
                            question.category,
                            question.text,
                            e.target.value
                          )
                        }
                      />
                      {option}
                    </label>
                  ))}
                </div>
              ) : null}
            </div>
          ))}

        <button type="submit" className="submit-button">
          Submit
        </button>
      </form>
    </div>
  );
}

export default Feedback;
